<template>
  <!-- Datadog would otherwise name clicks after their text, and the sheet teleports to the body, outside its page's action name -->
  <BaseBottomSheet
    ref="sheetRef"
    :title="$t('eu__prescription_upload__confirmation__header')"
    data-qa="confirmation"
    data-dd-action-name="Prescription upload agreement"
  >
    <BaseBanner variant="info">
      <DocumentViewer
        class="kds-typography-paragraph-medium"
        :link="consentText"
      />
    </BaseBanner>
    <template #footer>
      <div class="kds-content-block">
        <BaseButton
          :text="$t('eu__prescription_upload__confirmation__primary_cta')"
          data-qa="confirmation-submit"
          data-dd-action-name="Agree to prescription processing"
          @click="emit('confirm')"
        />
        <BaseButton
          variant="outlined"
          :text="$t('eu__prescription_upload__confirmation__secondary_cta')"
          data-qa="confirmation-cancel"
          data-dd-action-name="Cancel prescription processing"
          @click="emit('cancel')"
        />
      </div>
    </template>
  </BaseBottomSheet>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useI18n } from 'petite-vue-i18n'
import env from '@shared/env.js'
import useUserStore from '@shared/stores/useUserStore.js'
import defineLanguage from '@shared/utils/defineLanguage.js'
import BaseBanner from '@shared/components/BaseBanner.vue'
import BaseBottomSheet from '@shared/components/BaseBottomSheet.vue'
import BaseButton from '@shared/components/BaseButton.vue'
import DocumentViewer from '@shared/components/DocumentViewer.vue'

const props = defineProps({
  // Replaces the standard text for a flow whose consent has other wording
  description: {
    type: String,
    default: null,
  },
})
const emit = defineEmits(['confirm', 'cancel'])

const { t } = useI18n()
const userStore = useUserStore()
const sheetRef = ref(null)

const consentText = computed(
  () =>
    props.description ??
    t('eu__prescription_upload__confirmation__description', {
      privacy_web: `${env.VITE_PUBLIC_PATH}static/${defineLanguage(userStore.lang)}/privacy-website/index.html`,
    }),
)

const open = () => sheetRef.value.open()
const close = () => sheetRef.value.close()

defineExpose({ open, close })
</script>
